export class HostDto {
   /*
   *
   */
    constructor(
      public id?: number,
      public identificationCode?: string,
      public email?: string,
      public name?: string,
      public surname?: string,
      public mobileNumber?: string,
      public registrationDate?: string,
      public lastUpdate?: string,
      public active?: boolean,
      public locale?: string
    ){}
    
}